import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import { useNavigate } from 'react-router-dom';
import Loader from '../../global/loader';
import apiRequest from '../../utils/apiRequest';

const TierCard = ({
  title,
  image,
  id,
}: {
  title: string;
  image: string;
  id: string;
}) => {
  const navigation = useNavigate();

  return (
    <div className='w-full h-[100px] border-b-[1px] flex items-center justify-between px-5'>
      <div className='flex items-center gap-[20px]'>
        <img
          src={image}
          className='h-[60px] w-[60px] rounded-full overflow-clip  object-cover border-1'
        />
        <div className='text-[20px] font-semibold'>{title}</div>
      </div>
      <div
        className='text-[#482B14] text-[14px] leading-[16px] underline cursor-pointer'
        onClick={() => navigation(`/tier/form?type=edit&id=${id}`)}
      >
        Edit Configuration
      </div>
    </div>
  );
};

interface TireData {
  tierName: string;
  tierIcon: string;
  tierId: string;
}

const Tier = () => {
  const [loader, setLoader] = useState(true);
  const [tireData, setTierData] = useState<TireData[]>([]);
  const navigation = useNavigate();

  const getData = async () => {
    setLoader(true);
    const res = await apiRequest('getAllTier');
    setLoader(false);

    if (res?.error) {
    } else {
      setTierData(res?.data);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {loader && <Loader showHide={loader} />}
      {!loader && (
        <div className='px-5'>
          <Header title='VIP' />

          <div className='flex gap-3'>
            <div className='w-[250px] '>
              <div className='text-[16px] font-semibold'>VIP tiers</div>
              <div className='text-[13px] my-2 mb-5 leading-[16px] text-gray-500 font-normal'>
                Create VIP tiers to reward your most loyal customers while
                increasing your average customer lifetime value. Learn more
                about
                <div className='text-blue-500 cursor-pointer font-normal'>
                  adding a new VIP tier.
                </div>
              </div>

              <span
                className='py-[10px] px-[13px] rounded-[10px] text-[16px] bg-black  text-white cursor-pointer'
                onClick={() => navigation('/tier/form')}
              >
                Create Tier
              </span>
            </div>
            <div className='w-[75%] ml-auto mr-0 bg-white'>
              <div className=' px-3 py-3 font-semibold text-[16px] border-b-[1px]'>
                VIP TIERS
              </div>
              <div>
                {tireData &&
                  tireData?.map((data, i) => {
                    console.log(data);
                    return (
                      <>
                        <TierCard
                          key={i}
                          title={data?.tierName}
                          image={
                            data?.tierIcon === ''
                              ? 'https://placehold.co/400'
                              : data?.tierIcon
                          }
                          id={data?.tierId}
                        />
                      </>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Tier;
